"<template>
	<v-row>
		<v-col>
			<v-select label="Theme" v-model="question.cn_theme" :items="['Prozess', 'Ergebnis', 'Struktur']"></v-select>
		</v-col>
		<v-col cols="12" sm="8">
			<v-select label="Heading" v-model="question.cn_heading" :items="headings" item-text="title" item-value="name"></v-select>
		</v-col>
	</v-row>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "CheckitNowSettings", 
		props: {
			elements: {type: Array },			
			question: {type: Object}
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		computed: {
			headings(){
				return this.elements.filter( element => element.renderAs == 'cn_header' );
			}
			// ...Vuex.mapState({})
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"